import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services*/
import { ScreenService, StateService, ObservableObjectsService, DevicesService, CachedDataService, AppService } from '@services';

/*Models*/
import { ObservableObject, Device, DeviceState } from '@models';

/*Config */
import { CONFIG } from './../../config';

@Component({
  selector: 'app-online',
  templateUrl: './online.component.html',
  styleUrls: ['./online.component.scss']
})

export class OnlineComponent implements OnInit, OnDestroy {
  @ViewChild('selectObjectModal') selectObjectModal;
  @ViewChild('gmap') gmapElement: any;

  currentObservableObject: ObservableObject;
  currentDevice: Device;
  currentObject: ObservableObject;
  state: DeviceState;
  currentDeviceId;
  currentObjectId;
  observableObjects: Array<ObservableObject>;
  isSyncState = false;
  isLoadData = true;
  ifLoadDevice = true;
  ifWatchAnotherUser = false;

  private routerEventsSubscribe;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private UpdateTimer;
  private UpdateTimerInterval = CONFIG.intervalUpdateState;

  constructor(
    private cachedDataService: CachedDataService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    public screenService: ScreenService,
    private stateService: StateService,
    private observableObjectsService: ObservableObjectsService,
    private devicesService: DevicesService,
    private appService: AppService) {

    this.activeRoute.params.subscribe(params => {
      /*open modal select device */
      this.observableObjectsService.getAll()
        .subscribe(response => {
          this.observableObjects = this.appService.filterObjects(response);
          this.cachedDataService.setObservableObjects(this.observableObjects);
          if (this.observableObjects.length) {
            if (!params['deviceId'] || !params['objectId']) {
              /*if has object, select device */
              if(!this.cachedDataService.needUpdatePassword){
                setTimeout(() => {
                  this.selectObjectModal.open(true);
                }, 100);
              }
            } else {
              this.currentDeviceId = params['deviceId'];
              this.cachedDataService.setCurrentDeviceId(this.currentDeviceId);
            }
          } else {
            /*if no object */
            this.router.navigate(['/personal']);
          }

        },
          error => {
            console.log('from component error', error);
          }
        );
    });
  }




  ngOnInit() {
    this.screenService.isDataLoadingSubject.next(true);
    this.screenService.isShowLoader = false;
    this.stateService.autoUpdatePositionSubject.next(true);

    this.observableObjects = this.cachedDataService.getObservableObjects();

    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        this.currentObservableObject = object;
      });
    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });
    this.stateService.stateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(state => {
        this.state = state;
        this.upDateTimerSet();
      });
    this.screenService.isDataLoadingObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.isLoadData = value;
      });
    this.stateService.isSyncStateObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(value => {
        this.isSyncState = value;
      });

    this.routerEventsSubscribe = this.router.events
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          if (this.activeRoute.snapshot.params['deviceId'] && this.currentDevice) {
            if (this.activeRoute.snapshot.params['deviceId'] !== this.currentDevice.id) {
              this.setupCurrenDevice();
            } else {
              this.stateService.loadState();
            }
          }
        }
      });

    this.screenService.initMap(this.gmapElement.nativeElement);
    this.setupCurrenDevice();
  }

  getLastStateTime() {
    return this.stateService.getLastStateTime();
  }

  setupCurrenDevice() {
    this.screenService.isDataLoadingSubject.next(true);

    this.currentDeviceId = this.activeRoute.snapshot.params['deviceId'];
    this.currentObjectId = this.activeRoute.snapshot.params['objectId'];

    if (!this.currentDeviceId || !this.currentObjectId) {
      this.router.navigate(['/online']);
      return;
    }
    this.ifLoadDevice = true;

    this.getObject();

  }

  getObject() {
    // this.stateService.currentDeviceSubject.next(null);
    this.observableObjectsService.getObjectById(this.currentObjectId)
      .subscribe(response => {
        if (response) {
          this.currentObject = response;
          this.cachedDataService.currentUserId = this.currentObject.user.id;
          this.cachedDataService.ifWatchAnotherUser = this.checkIsWatchAnotherUser();
          this.ifWatchAnotherUser = this.cachedDataService.ifWatchAnotherUser;
          this.getDevice();
        } else {
          this.ifLoadDevice = false;
          this.router.navigate(['/online']);
        }
      },
        error => {
          this.ifLoadDevice = false;
          this.router.navigate(['/online']);
          console.log('from component error', error);
        }
      );
  }

  checkIsWatchAnotherUser(): boolean {
    return this.observableObjects.filter(object => object.id === this.currentObject.id)[0] === undefined;
  }
  getDevice() {
    this.devicesService.getDeivesByObjectId(this.currentObject.id)
      .subscribe(response => {
        if (response && response.data.length) {
          const device = response.data.filter(x => x.id === this.currentDeviceId)[0];
          if (device) {

            this.currentDevice = device;
            this.stateService.setCurrentObject(this.currentObject);
            this.stateService.setCurrentDevice(this.currentDevice);

            this.cachedDataService.setCurrentDevice(this.currentDevice);
            this.stateService.loadState();
          } else {
            this.router.navigate(['/online']);
          }

        } else {
          this.router.navigate(['/online']);
        }
        this.ifLoadDevice = false;
      },
        error => {
          this.ifLoadDevice = false;
          this.router.navigate(['/online']);
          console.log('from component error', error);
        }
      );
  }

  syncState() {
    this.stateService.syncState(true);
  }

  selectObject() {
    this.selectObjectModal.open();
  }

  upDateTimerSet(customInterval?) {
    if (this.UpdateTimer != null) {
      clearTimeout(this.UpdateTimer);
      this.UpdateTimer = null;
    }
    this.UpdateTimer = setInterval(() => {
      if (!this.ifLoadDevice) {
        this.stateService.syncState(true);
      }
    }, customInterval ? customInterval : this.UpdateTimerInterval);
  }

  triggerState() {
    this.screenService.isStateHidden = !this.screenService.isStateHidden;
    this.screenService.triggerStateSubject.next(this.screenService.isStateHidden);
  }

  ngOnDestroy() {
    this.routerEventsSubscribe.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    clearTimeout(this.UpdateTimer);
    this.UpdateTimer = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/view/online/online.component.ts